import request from '@/utils/request'

// 接入认证中心 
export function getLoginApi(params) {
  return request({
    url: '/api/server/login',
    method: 'POST',
    data: params
  })
}

export function getUserInfoApi() {
  return request({
    url: '/api/api/users/current',
    method: 'get',
   
  })
}

// 用户模块
export function getUserListApi(params) {
  return request({
    url: '/api/api/users',
    method: 'get',
    params
  })
}

export function addUserApi(data) {
  return request({
    url: '/api/api/users',
    method: 'post',
    data
  })
}
// 重置密码
export function resetPasswordApi(userId) {
  return request({
    url: `/api/api/reset/${userId}`,
    method: 'put',
   
  })
}

export  function getRoleApi() {
  return request({
    url: '/api/api/role',
    method: 'get'
  })
}

export function editUserApi(data) {
  return request({
    url: '/api/api/users',
    method: 'put',
    data
  })
}

export function deleteUserApi(userId) {
  return request({
    url: `/api/api/users/${userId}`,
    method: 'delete'
  })
}
// 节点模块
export function getNodeListApi(params) {
  return request({
    url: '/api/api/proxies',
    method: 'get',
    params
  })
}

export function addNodeApi(data) {
  return request({
     url: '/api/api/proxies',
    method: 'post',
    data
  })
}

export function editNodeApi(data) {
  return request({
    url: '/api/api/proxies',
    method: 'put',
    data
  })
}

export function deleteNodeApi(proxyId) {
  return request({
    url: `/api/api/proxies/${proxyId}`,
    method: 'delete'
  })
}

// 绑定关系
export function getBindListApi(params) {
  return request({
    url: '/api/api/user-proxies',
    method: 'get',
    params
  })
}

export function addBindApi(data) {
  return request({
    url: '/api/api/user-proxies/assign',
    method: 'post',
    data
  })
}



// 用户绑定节点的数据查询
export function getUserSingListApi(userId) {
  return request({
    url: `/api/api/user-proxies/user?userId=${userId}`,
    method: 'get',
   
  })
}

export function deleteUserSingApi(data) {
  return request({
    url: `/api/api/user-proxies/unassign`,
    method: 'post',
    data
  })
}